import { api } from "./client";
import type {
  AttemptDetail,
  AttemptHistoryItem,
  ExamAttemptReviewResponse,
  ExamAttemptStartResponse,
  SubmitAnswerRequest,
} from "@/types";

export const attemptsApi = {
  start(examId: string) {
    return api.post<ExamAttemptStartResponse>("/attempts", { exam_id: examId });
  },

  submitAnswer(attemptId: string, data: SubmitAnswerRequest) {
    return api.put<void>(`/attempts/${attemptId}/answer`, data);
  },

  complete(attemptId: string) {
    return api.post<AttemptDetail>(`/attempts/${attemptId}/complete`);
  },

  getById(attemptId: string) {
    return api.get<AttemptDetail>(`/attempts/${attemptId}`);
  },

  getReview(attemptId: string) {
    return api.get<ExamAttemptReviewResponse>(`/attempts/${attemptId}/review`);
  },

  getHistory(page = 1, pageSize = 20) {
    return api.get<AttemptHistoryItem[]>("/attempts/history", { page, page_size: pageSize });
  },
};
